module.exports = __webpack_public_path__ + "img/stamp-shrubbery-hubbery.9c47d269.png";